import {AbstractControl} from '@angular/forms';
import {Directive} from '@angular/core';
import {Input} from '@angular/core';
import {NG_VALIDATORS} from '@angular/forms';
import {OnChanges} from '@angular/core';
import {SimpleChanges} from '@angular/core';
import {Validator} from '@angular/forms';
import {ValidatorFn} from '@angular/forms';
import {Validators} from '@angular/forms';

function isValidNameFormat(name: string): boolean {
    return !/[!@#$%^&*()<>]/.test(name);
}

export function nameValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
        const { value } = control;
        if (value) {
            return isValidNameFormat(value) ? null : { 'name': { value } };
        }
    };
}

@Directive({
    selector: '[nameValidator]',
    providers: [{ provide: NG_VALIDATORS, useExisting: NameValidatorDirective, multi: true }]
})
export class NameValidatorDirective implements Validator, OnChanges {

    private _valFn = Validators.nullValidator;

    @Input()
    nameValidator: string;

    ngOnChanges(changes: SimpleChanges): void {
        this._valFn = changes['nameValidator'] ? nameValidator() : Validators.nullValidator;
    }

    validate(control: AbstractControl): { [key: string]: any } {
        return this._valFn(control);
    }

}
